import { apiRequest } from "@/utils/common/serviceApiHelper/serviceApiUtils";

import { ResponseCommonPresenter } from "../common/commonClassPresenter";
import type {
  RequestChangePasswordInterface,
  RequestDeleteAccountInterface,
  RequestUnSyncSocialInterface,
  RequestUpdatePhoneInterface,
  RequestUpdateProfilePhoneInterface,
} from "./profileServiceInterface/accountInterface";
import type {
  RequestEmailAndPasswordLoginInterface,
  RequestEmailLoginInterface,
} from "./profileServiceInterface/emailLoginInterface";
import type { RequestIsSubscribe } from "./profileServiceInterface/googleLoginInterface";
import type { RequestPhoneLoginInterface } from "./profileServiceInterface/phoneLoginInterface";
import type {
  RequestEmailClass,
  RequestEmailInterface,
  RequestPhoneClass,
  RequestPostAddBookingToAccount,
  RequestPostChangeMailWithOTPInterface,
  RequestPostCheckCodeVerificationMailInterface,
  RequestPostCheckCodeVerificationSMSInterface,
  RequestPostCreateInterface,
  RequestPostCreateSocialLoginInterface,
  RequestPostIsSubscribeInterface,
  RequestPostLoginInterface,
  RequestPostLoginPhonePasswordClass,
  RequestPostSavePasswordClass,
  RequestPostSyncSocialAccountInterface,
  RequestPostUnSyncSocialInterface,
  RequestPostUpdateBirthDayInterface,
  RequestPostUpdateInterface,
  RequestSocialAccountInterface,
} from "./profileServiceInterface/requestProfileInterface";
import {
  ResponseCommonWithTokenPresenter,
  ResponsePostAddBookingToAccountPresenter,
  ResponsePostCheckExistingEmailPresenter,
  ResponsePostSendCodeVerificationMailPresenter,
  ResponsePostSendCodeVerificationMailV5Presenter,
  ResponsePostSendCodeVerificationSmsPresenter,
  ResponsePostSendSMSVerificationPresenter,
  ResponseProfilePresenter,
} from "./profileServiceInterface/responseProfileInterface";
import type { RequestVerifyOptInterfaceInterface } from "./profileServiceInterface/verifyOptInterface";

class ProfileServiceApi {
  private baseUrl: string;

  private basePath: string;

  private accountPath: string;

  private accountPathV5: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
    this.basePath = "v2/account/profile";
    this.accountPath = "v2/account";
    this.accountPathV5 = "v5/account";
  }

  // ******************************************************
  // ****************** Method: POST **********************
  // ******************************************************

  // TODO - มาทำ presenter ด้วย
  async loginOtp(params: RequestPhoneLoginInterface) {
    return apiRequest(
      this.baseUrl,
      `${this.basePath}/sendSMSVerification`,
      "POST",
      params,
    );
  }

  // TODO - มาทำ presenter ด้วย
  async verifyOtp(params: RequestVerifyOptInterfaceInterface) {
    return apiRequest(
      this.baseUrl,
      `${this.basePath}/checkCodeVerificationSMS`,
      "POST",
      params,
    );
  }

  // TODO - มาทำ presenter ด้วย
  async loginEmail(params: RequestEmailLoginInterface) {
    return apiRequest(
      this.baseUrl,
      `${this.basePath}/checkExistingEmail`,
      "POST",
      params,
    );
  }

  // TODO - มาทำ presenter ด้วย
  async loginEmailPassword(params: RequestEmailAndPasswordLoginInterface) {
    return apiRequest(this.baseUrl, `${this.basePath}/login`, "POST", params);
  }

  // TODO - มาทำ presenter ด้วย
  async sendMailResetPasword(params: { email: string; lang: string }) {
    return apiRequest(
      this.baseUrl,
      `${this.basePath}/sendMailResetPasword`,
      "POST",
      params,
    );
  }

  // TODO - มาทำ presenter ด้วย
  async isSubscribe(params: RequestIsSubscribe) {
    return apiRequest(
      this.baseUrl,
      `${this.basePath}/isSubscribe`,
      "POST",
      params,
    );
  }

  // TODO - มาทำ presenter ด้วย
  async updateProfilePhone(params: RequestUpdateProfilePhoneInterface) {
    return apiRequest(this.baseUrl, `${this.basePath}/update`, "POST", params);
  }

  // TODO - มาทำ presenter ด้วย
  async updatePhone(params: RequestUpdatePhoneInterface) {
    return apiRequest(
      this.baseUrl,
      `${this.basePath}/updatePhone`,
      "POST",
      params,
    );
  }

  // TODO - มาทำ presenter ด้วย
  async UnSyncSocial(params: RequestUnSyncSocialInterface) {
    return apiRequest(
      this.baseUrl,
      `${this.basePath}/unSyncSocial`,
      "POST",
      params,
    );
  }

  // TODO - มาทำ presenter ด้วย
  async changePassword(params: RequestChangePasswordInterface) {
    return apiRequest(
      this.baseUrl,
      `${this.basePath}/changePassword`,
      "POST",
      params,
    );
  }

  // TODO - มาทำ presenter ด้วย
  async deleteAccount(params: RequestDeleteAccountInterface) {
    return apiRequest(this.baseUrl, `${this.basePath}/delete`, "POST", params);
  }

  // NOTE - New
  async postGetProfileAcount(params?: { accountIdForce?: string }) {
    try {
      const response = (await apiRequest(
        this.baseUrl,
        `${this.basePath}/getProfile`,
        "POST",
        params,
      )) as any;

      return new ResponseProfilePresenter(response);
    } catch {
      return new ResponseProfilePresenter({});
    }
  }

  async postSendCodeVerificationMail(params: RequestEmailClass) {
    try {
      const response = await apiRequest(
        this.baseUrl,
        `${this.basePath}/sendCodeVerificationMail`,
        "POST",
        params,
      );
      return new ResponsePostSendCodeVerificationMailPresenter(response);
    } catch (error) {
      return new ResponsePostSendCodeVerificationMailPresenter({});
    }
  }

  async postCheckCodeVerificationMail(
    params: RequestPostCheckCodeVerificationMailInterface,
  ) {
    try {
      const response = await apiRequest(
        this.baseUrl,
        `${this.basePath}/checkCodeVerificationMail`,
        "POST",
        params,
      );
      return new ResponseCommonPresenter(response);
    } catch (error) {
      return new ResponseCommonPresenter({});
    }
  }

  async postLoginPhonePassword(params: RequestPostLoginPhonePasswordClass) {
    try {
      const response = (await apiRequest(
        this.baseUrl,
        `${this.basePath}/loginPhonePassword`,
        "POST",
        params,
      )) as any;

      return new ResponseProfilePresenter(response);
    } catch (error) {
      return new ResponseProfilePresenter({});
    }
  }

  async postSendOtpVerification(params: RequestPhoneClass) {
    try {
      const response = (await apiRequest(
        this.baseUrl,
        `${this.basePath}/sendSMSVerification`,
        "POST",
        params,
      )) as any;
      return new ResponsePostSendCodeVerificationSmsPresenter(response);
    } catch {
      return new ResponsePostSendCodeVerificationSmsPresenter({});
    }
  }

  async postCheckCodeVerificationSMS(
    params: RequestPostCheckCodeVerificationSMSInterface,
  ) {
    try {
      const response = (await apiRequest(
        this.baseUrl,
        `${this.basePath}/checkCodeVerificationSMS`,
        "POST",
        params,
      )) as any;
      return new ResponseCommonWithTokenPresenter(response);
    } catch {
      return new ResponseCommonWithTokenPresenter({});
    }
  }

  async postLogin(params: RequestPostLoginInterface) {
    try {
      const response = await apiRequest(
        this.baseUrl,
        `${this.basePath}/login`,
        "POST",
        params,
      );

      return new ResponseProfilePresenter(response);
    } catch {
      return new ResponseProfilePresenter({});
    }
  }

  async postCheckExistingEmail(params: RequestEmailClass) {
    try {
      const response = await apiRequest(
        this.baseUrl,
        `${this.basePath}/checkExistingEmail`,
        "POST",
        params,
      );
      return new ResponsePostCheckExistingEmailPresenter(response);
    } catch {
      return new ResponsePostCheckExistingEmailPresenter({});
    }
  }

  async postSavePassword(params: RequestPostSavePasswordClass) {
    try {
      const response = await apiRequest(
        this.baseUrl,
        `${this.basePath}/savePassword`,
        "POST",
        params,
      );
      return new ResponseCommonPresenter(response);
    } catch {
      return new ResponseCommonPresenter({});
    }
  }

  async postCreateWithVerify(params: RequestPostCreateInterface) {
    try {
      const response = await apiRequest(
        this.baseUrl,
        `${this.basePath}/createWithVerify`,
        "POST",
        params,
      );

      return new ResponseProfilePresenter(response);
    } catch {
      return new ResponseProfilePresenter({});
    }
  }

  async postSyncSocialAccount(params: RequestPostSyncSocialAccountInterface) {
    try {
      const response = await apiRequest(
        this.baseUrl,
        `${this.basePath}/syncSocialAccount`,
        "POST",
        params,
      );
      return new ResponseCommonPresenter(response);
    } catch {
      return new ResponseCommonPresenter({});
    }
  }

  async postCreateSocialLogin(params: RequestPostCreateSocialLoginInterface) {
    try {
      const response = await apiRequest(
        this.baseUrl,
        `${this.basePath}/createSocialLogin`,
        "POST",
        params,
      );

      return new ResponseProfilePresenter(response);
    } catch {
      return new ResponseProfilePresenter({});
    }
  }

  async postSendMailResetPasword(params: RequestEmailInterface) {
    try {
      const response = await apiRequest(
        this.baseUrl,
        `${this.basePath}/sendMailResetPasword`,
        "POST",
        params,
      );
      return new ResponseCommonPresenter(response);
    } catch {
      return new ResponseCommonPresenter({});
    }
  }

  async postRestoreAccount() {
    try {
      const response = await apiRequest(
        this.baseUrl,
        `${this.basePath}/restoreAccount`,
        "POST",
      );
      return new ResponseCommonPresenter(response);
    } catch {
      return new ResponseCommonPresenter({});
    }
  }

  async postUpdate(params: RequestPostUpdateInterface) {
    try {
      const response = await apiRequest(
        this.baseUrl,
        `${this.basePath}/update`,
        "POST",
        params,
      );
      return new ResponseCommonPresenter(response);
    } catch {
      return new ResponseCommonPresenter({});
    }
  }

  async postAddEmailWithOTP(params: RequestPostCreateInterface) {
    try {
      const response = await apiRequest(
        this.baseUrl,
        `${this.basePath}/addEmailWithOTP`,
        "POST",
        params,
      );
      return new ResponseCommonPresenter(response);
    } catch {
      return new ResponseCommonPresenter({});
    }
  }

  async postChangeMailWithOTP(params: RequestPostChangeMailWithOTPInterface) {
    try {
      const response = await apiRequest(
        this.baseUrl,
        `${this.basePath}/changeMailWithOTP`,
        "POST",
        params,
      );
      return new ResponseCommonPresenter(response);
    } catch {
      return new ResponseCommonPresenter({});
    }
  }

  async postAddSocialAccount(params: RequestSocialAccountInterface) {
    try {
      const response = await apiRequest(
        this.baseUrl,
        `${this.basePath}/addSocialAccount`,
        "POST",
        params,
      );
      return new ResponseCommonPresenter(response);
    } catch {
      return new ResponseCommonPresenter({});
    }
  }

  async postUnSyncSocial(params: RequestPostUnSyncSocialInterface) {
    try {
      const response = await apiRequest(
        this.baseUrl,
        `${this.basePath}/unSyncSocial`,
        "POST",
        params,
      );
      return new ResponseCommonPresenter(response);
    } catch {
      return new ResponseCommonPresenter({});
    }
  }

  async postUpdateBirthDay(params: RequestPostUpdateBirthDayInterface) {
    try {
      const response = await apiRequest(
        this.baseUrl,
        `${this.basePath}/updateBirthday`,
        "POST",
        params,
      );
      return new ResponseCommonPresenter(response);
    } catch {
      return new ResponseCommonPresenter({});
    }
  }

  async postIsSubscribe(params: RequestPostIsSubscribeInterface) {
    try {
      const response = await apiRequest(
        this.baseUrl,
        `${this.basePath}/isSubscribe`,
        "POST",
        params,
      );
      return new ResponseCommonPresenter(response);
    } catch {
      return new ResponseCommonPresenter({});
    }
  }

  async postUpdatePhone(params: RequestPhoneClass) {
    try {
      const response = await apiRequest(
        this.baseUrl,
        `${this.basePath}/updatePhone`,
        "POST",
        params,
      );
      return new ResponsePostSendCodeVerificationSmsPresenter(response);
    } catch {
      return new ResponsePostSendCodeVerificationSmsPresenter({});
    }
  }

  async postAddBookingToAccount(params: RequestPostAddBookingToAccount) {
    try {
      const response = await apiRequest(
        this.baseUrl,
        `${this.accountPath}/addBookingToAccount`,
        "POST",
        params,
      );
      return new ResponsePostAddBookingToAccountPresenter(response);
    } catch {
      return new ResponsePostAddBookingToAccountPresenter({});
    }
  }

  async postSendSMSVerificationV5(params: RequestPhoneClass) {
    try {
      const response = (await apiRequest(
        this.baseUrl,
        `${this.accountPathV5}/sendSMSVerification`,
        "POST",
        params,
      )) as any;
      return new ResponsePostSendSMSVerificationPresenter(response);
    } catch {
      return new ResponsePostSendSMSVerificationPresenter({});
    }
  }

  async postCheckCodeVerificationSmsV5(
    params: RequestPostCheckCodeVerificationSMSInterface,
  ) {
    try {
      const response = (await apiRequest(
        this.baseUrl,
        `${this.accountPathV5}/checkCodeVerificationSMS`,
        "POST",
        params,
      )) as any;
      return new ResponsePostSendSMSVerificationPresenter(response);
    } catch {
      return new ResponsePostSendSMSVerificationPresenter({});
    }
  }

  async postSendCodeVerificationMailV5(params: RequestEmailClass) {
    try {
      const response = await apiRequest(
        this.baseUrl,
        `${this.accountPathV5}/sendCodeVerificationMail`,
        "POST",
        params,
      );
      return new ResponsePostSendCodeVerificationMailV5Presenter(response);
    } catch (error) {
      return new ResponsePostSendCodeVerificationMailV5Presenter({});
    }
  }

  async postCheckCodeVerificationMailV5(
    params: RequestPostCheckCodeVerificationMailInterface,
  ) {
    try {
      const response = await apiRequest(
        this.baseUrl,
        `${this.accountPathV5}/checkCodeVerificationMail`,
        "POST",
        params,
      );
      return new ResponsePostSendCodeVerificationMailV5Presenter(response);
    } catch (error) {
      return new ResponsePostSendCodeVerificationMailV5Presenter({});
    }
  }

  async postUpdatePhoneV5(params: RequestPhoneClass) {
    try {
      const response = await apiRequest(
        this.baseUrl,
        `${this.accountPathV5}/updatePhone`,
        "POST",
        params,
      );
      return new ResponsePostSendSMSVerificationPresenter(response);
    } catch {
      return new ResponsePostSendSMSVerificationPresenter({});
    }
  }
}

export default ProfileServiceApi;
